var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-box',{attrs:{"type":"danger","closable":false,"show-icon":false}},[_vm._v(" "+_vm._s(_vm.$label("common.not_found", "Not found"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }